// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"367":"7b303a49","623":"ab742652"}[chunkId] + ".chunk.js";
};